/**
 * Testimonial dome — vanilla port of src/components/DomeGallery.jsx
 * (adapted from React Bits' Dome Gallery).
 *
 * Tiles sit on the inside of a sphere you drag around; clicking one enlarges
 * it in the middle. Three kinds of tile: comment (quote card), video (poster,
 * plays when opened) and image. Items are read from the section's JSON.
 */
(function () {
  var clamp = function (v, min, max) { return Math.min(Math.max(v, min), max); };
  var normalizeAngle = function (d) { return ((d % 360) + 360) % 360; };
  var wrapAngleSigned = function (deg) { var a = (((deg + 180) % 360) + 360) % 360; return a - 180; };
  var num = function (el, name, fallback) {
    var v = parseFloat(el.getAttribute('data-' + name));
    return isFinite(v) ? v : fallback;
  };

  /* Spread photos, quotes and clips evenly round the sphere: each step takes
     from whichever list is proportionally furthest behind. */
  function interleave(lists) {
    lists = lists.filter(function (l) { return l.length; });
    var cursors = lists.map(function () { return 0; });
    var total = lists.reduce(function (n, l) { return n + l.length; }, 0);
    var out = [];
    while (out.length < total) {
      var best = -1, bestScore = Infinity;
      lists.forEach(function (l, i) {
        if (cursors[i] >= l.length) return;
        var score = (cursors[i] + 0.5) / l.length;
        if (score < bestScore) { bestScore = score; best = i; }
      });
      out.push(lists[best][cursors[best]]);
      cursors[best] += 1;
    }
    return out;
  }

  /* Columns of fixed width, filled top-to-bottom with tiles whose height comes
     from the item's aspect; each column is then scaled to span exactly colSpan. */
  var SIZE_X = 2;
  function buildItems(pool, seg, colSpan) {
    var yStart = -colSpan / 2 - 0.5;
    var out = [];
    if (!pool.length) return out;
    var p = 0;
    for (var ci = 0; ci < seg; ci++) {
      var x = -37 + ci * 2;
      var col = [], sum = 0;
      while (sum < colSpan - 0.5) {
        var item = pool[p % pool.length]; p += 1;
        var h = clamp(SIZE_X / (item.aspect || 1), 1.3, 4);
        col.push({ item: item, h: h }); sum += h;
      }
      var k = colSpan / sum;
      var cursor = yStart + (ci % 2 ? 1 : 0);
      col.forEach(function (c) {
        var sizeY = c.h * k;
        var center = cursor + sizeY / 2;
        out.push({ x: x, y: center + (sizeY - 1) / 2, sizeX: SIZE_X, sizeY: sizeY, item: c.item });
        cursor += sizeY;
      });
    }
    return out;
  }

  function baseRotation(offsetX, offsetY, sizeX, sizeY, segments) {
    var unit = 360 / segments / 2;
    return { rotateY: unit * (offsetX + (sizeX - 1) / 2), rotateX: unit * (offsetY - (sizeY - 1) / 2) };
  }

  /* ---------- DOM builders ---------- */
  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }
  function buildCard(item, open) {
    var card = el('div', 'dg-card' + (open ? ' dg-card--open' : ''));
    card.appendChild(el('span', 'dg-card__stars', '★'.repeat(item.rating || 5)));
    card.appendChild(el('p', 'dg-card__body', item.body));
    card.appendChild(el('b', 'dg-card__name', item.name));
    return card;
  }
  function buildImg(src, alt) {
    var img = el('img');
    img.src = src; img.alt = alt || ''; img.draggable = false;
    img.style.cssText = 'width:100%;height:100%;object-fit:cover;';
    return img;
  }
  function buildFace(item) {
    if (item.kind === 'comment') return buildCard(item, false);
    /* Whichever copy is in the cache: the original once upgrade() has it, else the tile's. */
    if (item.kind === 'video') return buildImg(warmed[item.poster] === true ? item.poster : (item.posterThumb || item.poster), item.label);
    return buildImg(warmed[item.src] === true ? item.src : (item.thumb || item.src), item.alt);
  }
  /* Decode a tile image as soon as its bytes land (off the main thread), so
     no decode is left for the frame in which the tile first scrolls into
     view - that was a visible hitch when a visitor reached the globe early. */
  /* thumb is the CDN URL with "&width=440" on the end; the 680px sibling is
     the same URL at that width. If a CDN copy ever fails, the original is used. */
  function tileSources(img, thumb, original) {
    if (thumb && /&width=\d+$/.test(thumb)) {
      img.srcset = thumb + ' 440w, ' + thumb.replace(/&width=\d+$/, '&width=680') + ' 680w';
      img.sizes = '(max-width: 767px) 170px, 280px';
    }
    img.src = thumb || original;
    var fellBack = false;
    img.onerror = function () {
      if (fellBack || !original || !thumb) return;
      fellBack = true; img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = original;
    };
  }
  var decoded = {};
  function preDecode(img) {
    if (!img.decode || decoded[img.src]) return;
    decoded[img.src] = true;
    var go = function () { img.decode().catch(function () {}); };
    if (img.complete) go(); else img.addEventListener('load', go, { once: true });
  }
  function buildEnlarged(item) {
    if (item.kind === 'comment') return buildCard(item, true);
    if (item.kind === 'video') {
      var v = el('video');
      v.src = item.src; v.poster = item.posterThumb || item.poster || ''; v.controls = true;
      upgrade(item.poster, function (big) { v.poster = big; });
      v.playsInline = true; v.setAttribute('playsinline', ''); v.preload = 'auto';
      v.style.cssText = 'width:100%;height:100%;object-fit:cover;display:block;background:#000;';
      return v;
    }
    /* The tile holds the 440px copy, so the enlarge animates from that at
       once and switches to the original the moment it has arrived. */
    var full = buildImg(item.thumb || item.src, item.alt);
    upgrade(item.src, function (big) { full.src = big; });
    return full;
  }
  var warmed = {};
  /* Fetch the full-size asset (once per URL) and hand it over when it is ready. */
  function upgrade(src, apply) {
    if (!src) return;
    if (warmed[src] === true) { apply(src); return; }
    var big = new Image();
    big.onload = function () {
      var done = function () { warmed[src] = true; apply(src); };
      if (big.decode) big.decode().then(done, done); else done();
    };
    big.src = src;
  }
  function warm(src) { if (src && !warmed[src]) { warmed[src] = 'loading'; var big = new Image(); big.onload = function () { warmed[src] = true; }; big.src = src; } }
  function openedSize(item, frameR) {
    if (item.kind === 'comment') {
      var side = Math.round(Math.min(frameR.width, 460));
      return { w: side + 'px', h: side + 'px' };
    }
    var aspect = item.aspect || (item.kind === 'video' ? 9 / 16 : 1);
    var h = Math.min(frameR.height, 640), w = h * aspect;
    var maxW = Math.min(frameR.width, 620);
    if (w > maxW) { w = maxW; h = w / aspect; }
    return { w: Math.round(w) + 'px', h: Math.round(h) + 'px' };
  }
  function tileLabel(item) {
    if (item.kind === 'comment') return 'Read ' + item.name + "'s review";
    if (item.kind === 'video') return 'Play video: ' + (item.label || 'clip');
    return item.alt || 'Open image';
  }

  function initDome(root) {
    if (root.dataset.domeReady) return;
    root.dataset.domeReady = '1';

    var main = root.querySelector('[data-main]');
    var sphere = root.querySelector('[data-sphere]');
    var viewer = root.querySelector('[data-viewer]');
    var scrim = root.querySelector('[data-scrim]');
    var frame = root.querySelector('[data-frame]');
    var dataEl = root.parentElement.querySelector('[data-dome-items]');
    var raw = [];
    try { raw = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var photos = raw.filter(function (i) { return i.kind === 'image'; });
    var comments = raw.filter(function (i) { return i.kind === 'comment'; });
    var videos = raw.filter(function (i) { return i.kind === 'video'; });
    var pool = interleave([photos, comments, videos]);
    if (!pool.length) return;

    var cfg = {
      segmentsWide: num(root, 'segments-wide', 44),
      segmentsNarrow: num(root, 'segments-narrow', 30),
      colSpanWide: num(root, 'colspan-wide', 19),
      colSpanNarrow: num(root, 'colspan-narrow', 13),
      fit: num(root, 'fit', 0.56),
      minRadius: num(root, 'min-radius', 420),
      heightGuard: num(root, 'height-guard', 4),
      coverCorners: root.getAttribute('data-cover-corners') !== 'false',
      perspective: num(root, 'perspective', 2),
      padFactor: num(root, 'pad-factor', 0.12),
      autoRotate: num(root, 'autorotate', 1.6),
      maxVertical: 5,
      dragSensitivity: 20,
      dragDampening: 1,
      enlargeMs: 300
    };

    var rotation = { x: 0, y: 0 };
    var dragging = false, moved = false, opening = false;
    var inertiaRAF = null, lastDragEndAt = 0, openStartedAt = 0, spinDir = 1;
    var focusedEl = null, focusedItem = null, originalTilePos = null;
    var items = [];
    var segments = 0;

    function applyTransform(x, y) {
      sphere.style.transform = 'translateZ(calc(var(--radius) * -1)) rotateX(' + x + 'deg) rotateY(' + y + 'deg)';
    }

    /* ---------- render ---------- */
    function render() {
      var wide = window.innerWidth >= 1024;
      var seg = wide ? cfg.segmentsWide : cfg.segmentsNarrow;
      if (seg === segments) return;
      segments = seg;
      root.style.setProperty('--segments-x', seg);
      root.style.setProperty('--segments-y', seg);
      items = buildItems(pool, seg, wide ? cfg.colSpanWide : cfg.colSpanNarrow);
      sphere.innerHTML = '';
      var pending = items.slice();
      var batch = function () {
        var n = 0;
        /* Chunked only while the page is actually being painted; in a hidden or
           throttled document animation frames may never run, so drain in one go. */
        while (pending.length && (n < 24 || document.hidden)) { addTile(pending.shift()); n++; }
        if (pending.length) requestAnimationFrame(batch);
      };
      function addTile(it) {
        var i = items.indexOf(it);
        var wrap = el('div', 'item item--' + it.item.kind);
        wrap.setAttribute('data-index', i);
        wrap.setAttribute('data-offset-x', it.x);
        wrap.setAttribute('data-offset-y', it.y);
        wrap.setAttribute('data-size-x', it.sizeX);
        wrap.setAttribute('data-size-y', it.sizeY);
        wrap.style.setProperty('--offset-x', it.x);
        wrap.style.setProperty('--offset-y', it.y);
        wrap.style.setProperty('--item-size-x', it.sizeX);
        wrap.style.setProperty('--item-size-y', it.sizeY);
        var tile = el('div', 'item__image');
        tile.setAttribute('role', 'button');
        tile.setAttribute('tabindex', '0');
        tile.setAttribute('aria-label', tileLabel(it.item));
        if (it.item.kind === 'comment') {
          tile.appendChild(buildCard(it.item, false));
        } else if (it.item.kind === 'video') {
          var img = el('img'); img.decoding = 'async'; img.setAttribute('fetchpriority', 'low');
          tileSources(img, it.item.posterThumb, it.item.poster);
          preDecode(img); img.alt = it.item.label || ''; img.draggable = false;
          tile.appendChild(img);
          var play = el('span', 'dg-play'); play.setAttribute('aria-hidden', 'true');
          play.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18"><path d="M8 5.5v13l11-6.5z" fill="currentColor"/></svg>';
          tile.appendChild(play);
        } else {
          /* Tile-sized CDN copies, not the 900px original: the front tiles paint at
             up to ~280 CSS px, so 440px serves 1x/1.25x screens and 680px the 2x/3x
             ones (the browser picks by DPR from the srcset). */
          var im = el('img'); im.decoding = 'async'; im.setAttribute('fetchpriority', 'low');
          tileSources(im, it.item.thumb, it.item.src);
          preDecode(im); im.alt = it.item.alt || ''; im.draggable = false;
          tile.appendChild(im);
        }
        tile.addEventListener('click', onTileClick);
        /* Warm the original on a real hover (not a touch swipe) or keyboard focus, so a click is a cache hit. */
        var warmSrc = it.item.kind === 'image' ? it.item.src : (it.item.kind === 'video' ? it.item.poster : null);
        if (warmSrc && !saveData) {
          tile.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') warm(warmSrc); });
          tile.addEventListener('focus', function () { warm(warmSrc); });
        }
        tile.addEventListener('pointerup', function (e) { if (e.pointerType === 'touch') onTileClick(e); });
        tile.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onTileClick(e); } });
        wrap.appendChild(tile);
        sphere.appendChild(wrap);
      }
      batch();
      applyTransform(rotation.x, rotation.y);
    }

    /* ---------- sizing ---------- */
    function applySizing(w, h) {
      var minDim = Math.min(w, h);
      var radius = w * cfg.fit;                         // fitBasis: width
      radius = Math.min(radius, h * cfg.heightGuard);
      if (cfg.coverCorners) {
        /* The sphere's centre sits one radius behind the stage, the camera
           perspectiveFactor radii in front of it, so its outline on screen is
           p / sqrt(p^2 + 2p) of the radius. The frame corner must fall inside
           that outline (with a little margin for the tile gutters). */
        var p = cfg.perspective;
        var outline = p / Math.sqrt(p * p + 2 * p);
        radius = Math.max(radius, (Math.hypot(w, h) / 2 / outline) * 1.06);
      }
      radius = Math.max(radius, cfg.minRadius);
      root.style.setProperty('--radius', Math.round(radius) + 'px');
      root.style.setProperty('--viewer-pad', Math.max(8, Math.round(minDim * cfg.padFactor)) + 'px');
      applyTransform(rotation.x, rotation.y);
      var overlay = viewer.querySelector('.enlarge');
      if (overlay && focusedItem) {
        var frameR = frame.getBoundingClientRect(), mainR = main.getBoundingClientRect();
        var size = openedSize(focusedItem, frameR);
        overlay.style.left = (frameR.left - mainR.left + (frameR.width - parseFloat(size.w)) / 2) + 'px';
        overlay.style.top = (frameR.top - mainR.top + (frameR.height - parseFloat(size.h)) / 2) + 'px';
      }
    }
    function measure() {
      var r = root.getBoundingClientRect();
      applySizing(Math.max(1, r.width), Math.max(1, r.height));
    }
    /* Build lazily: the globe sits far below the fold, and creating 199 3D
       tiles + fetching 31 images at page open was the startup jank. The frame
       is sized immediately (layout stays stable); tiles are built when the
       visitor is within ~1.5 screens of it. */
    /* Data Saver: nothing speculative (no eager build, no hover prefetch). */
    var saveData = !!(navigator.connection && navigator.connection.saveData);
    var built = false;
    function build() { if (built) return; built = true; render(); measure(); }
    /* Within ~1.5 screens counts as near. Measured directly rather than trusting
       IntersectionObserver alone: callbacks are not delivered to hidden or
       background documents, which would leave the globe permanently empty. */
    function nearViewport() {
      var r = root.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight || 0;
      if (!vh) return true;
      return r.top < vh * 2.5 && r.bottom > -vh * 1.5;
    }
    measure();
    if (nearViewport()) build();
    if (!built) {
      var onScrollBuild = function () { if (nearViewport()) { window.removeEventListener('scroll', onScrollBuild); build(); } };
      window.addEventListener('scroll', onScrollBuild, { passive: true });
      var buildIO = null;
      if (window.IntersectionObserver) {
        buildIO = new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting) { buildIO.disconnect(); window.removeEventListener('scroll', onScrollBuild); build(); }
        }, { rootMargin: '150% 0px' });
        buildIO.observe(root);
      }
      /* Most visitors are scrolling down within a few seconds: build as soon
         as the page has loaded and the main thread is idle, so the tile images
         are fetched and decoded before anyone gets near the globe. The build
         itself is chunked (24 tiles a frame), so it never stalls the page. */
      var idleBuild = function () { window.removeEventListener('scroll', onScrollBuild); if (buildIO) buildIO.disconnect(); build(); };
      var onLoaded = function () { if (window.requestIdleCallback) window.requestIdleCallback(idleBuild, { timeout: 1500 }); else setTimeout(idleBuild, 800); };
      if (!saveData) {
        if (document.readyState === 'complete') onLoaded(); else window.addEventListener('load', onLoaded, { once: true });
        /* backstop: whatever happens, the globe is never left blank */
        setTimeout(idleBuild, 4000);
      }
      /* Data Saver: only the near-viewport triggers above, so nothing is fetched for a visitor who never scrolls down. */
    }
    if (window.ResizeObserver) {
      new ResizeObserver(function (entries) {
        var cr = entries[0].contentRect;
        applySizing(Math.max(1, cr.width), Math.max(1, cr.height));
      }).observe(root);
    }
    window.addEventListener('resize', function () { if (built) render(); measure(); });

    /* ---------- idle spin ---------- */
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    /* Spin only while the globe is actually on screen: a per-frame transform on
       ~100 3D layers is the single heaviest thing on the page, and it was
       running even when the visitor was reading the hero or the footer. */
    var onScreen = true, spinning = false;
    /* The page is scrolling: both the idle turn and a flick's inertia hold
       still while it is (released 140ms after the last scroll event). */
    var scrolling = false, scrollIdle = null;
    window.addEventListener('scroll', function () {
      scrolling = true;
      if (scrollIdle) clearTimeout(scrollIdle);
      scrollIdle = setTimeout(function () { scrolling = false; last = null; }, 140);
    }, { passive: true });
    if (window.IntersectionObserver) {
      onScreen = false;
      new IntersectionObserver(function (entries) {
        onScreen = entries[0].isIntersecting;
        if (onScreen && cfg.autoRotate && !reduced && !spinning) { spinning = true; last = null; requestAnimationFrame(spin); }
      }, { rootMargin: '120px 0px' }).observe(root);
    }
    if (cfg.autoRotate && !reduced) {
      var last = null;
      /* The turn is stepped every other frame, for everyone: at 1.6 deg/s a
         step is about a pixel at the front of the sphere (30 steps a second
         reads as continuous motion), and the compositor only redraws the ~450
         tile layers when the sphere actually moves, so the idle GPU load
         halves. Measured on integrated graphics that headroom is what keeps
         wheel scrolling at 60fps when the globe is on screen. */
      var skip = false;
      var spin = function (ts) {
        if (!onScreen) { spinning = false; return; }
        skip = !skip; if (skip) { requestAnimationFrame(spin); return; }
        if (last == null) last = ts;
        var dt = Math.min(ts - last, 100) / 1000;
        last = ts;
        if (!dragging && !inertiaRAF && !focusedEl && !opening && !scrolling) {
          rotation.y = wrapAngleSigned(rotation.y + spinDir * cfg.autoRotate * dt);
          applyTransform(rotation.x, rotation.y);
        }
        requestAnimationFrame(spin);
      };
      if (onScreen) { spinning = true; requestAnimationFrame(spin); }
    }

    /* ---------- inertia ---------- */
    function stopInertia() { if (inertiaRAF) { cancelAnimationFrame(inertiaRAF); inertiaRAF = null; } }
    function startInertia(vx, vy) {
      var MAX_V = 1.4;
      var vX = clamp(vx, -MAX_V, MAX_V) * 80, vY = clamp(vy, -MAX_V, MAX_V) * 80;
      var frames = 0, d = clamp(cfg.dragDampening, 0, 1);
      var friction = 0.94 + 0.055 * d, stopAt = 0.015 - 0.01 * d, maxFrames = Math.round(90 + 270 * d);
      if (vX !== 0) spinDir = vX > 0 ? 1 : -1;
      var handover = (cfg.autoRotate * 200) / 60;
      var step = function () {
        /* Same holds as the idle turn: nothing to show off screen, and no
           per-frame recomposite while the page itself is scrolling. */
        if (!onScreen) { inertiaRAF = null; return; }
        if (scrolling) { inertiaRAF = requestAnimationFrame(step); return; }
        vX *= friction; vY *= friction;
        if ((Math.abs(vX) < stopAt && Math.abs(vY) < stopAt) || (cfg.autoRotate > 0 && Math.abs(vX) <= handover) || ++frames > maxFrames) {
          inertiaRAF = null; return;
        }
        rotation.x = clamp(rotation.x - vY / 200, -cfg.maxVertical, cfg.maxVertical);
        rotation.y = wrapAngleSigned(rotation.y + vX / 200);
        applyTransform(rotation.x, rotation.y);
        inertiaRAF = requestAnimationFrame(step);
      };
      stopInertia();
      inertiaRAF = requestAnimationFrame(step);
    }

    /* ---------- drag (pointer events; no capture, so tile clicks still land) ---------- */
    var startRot = null, startPos = null, samples = [];
    function onMove(e) {
      if (!dragging || !startPos) return;
      var dx = e.clientX - startPos.x, dy = e.clientY - startPos.y;
      if (!moved && dx * dx + dy * dy > 16) moved = true;
      rotation.x = clamp(startRot.x - dy / cfg.dragSensitivity, -cfg.maxVertical, cfg.maxVertical);
      rotation.y = wrapAngleSigned(startRot.y + dx / cfg.dragSensitivity);
      applyTransform(rotation.x, rotation.y);
      samples.push({ t: performance.now(), x: e.clientX, y: e.clientY });
      if (samples.length > 6) samples.shift();
    }
    function onUp() {
      if (!dragging) return;
      dragging = false;
      document.removeEventListener('pointermove', onMove);
      document.removeEventListener('pointerup', onUp);
      document.removeEventListener('pointercancel', onUp);
      var vx = 0, vy = 0;
      if (samples.length >= 2) {
        var a = samples[0], b = samples[samples.length - 1], dt = Math.max(1, b.t - a.t);
        vx = (b.x - a.x) / dt; vy = (b.y - a.y) / dt;          // px per ms, like use-gesture
      }
      if (Math.abs(vx) > 0.005 || Math.abs(vy) > 0.005) startInertia(vx, vy);
      if (moved) lastDragEndAt = performance.now();
      setTimeout(function () { moved = false; }, 0);
    }
    main.addEventListener('pointerdown', function (e) {
      if (focusedEl || (e.button !== undefined && e.button !== 0)) return;
      stopInertia();
      dragging = true; moved = false;
      startRot = { x: rotation.x, y: rotation.y };
      startPos = { x: e.clientX, y: e.clientY };
      samples = [{ t: performance.now(), x: e.clientX, y: e.clientY }];
      document.addEventListener('pointermove', onMove);
      document.addEventListener('pointerup', onUp);
      document.addEventListener('pointercancel', onUp);
    });

    /* ---------- open ---------- */
    function lockScroll() { document.body.classList.add('dg-scroll-lock'); }
    function unlockScroll() { document.body.classList.remove('dg-scroll-lock'); }

    function onTileClick(e) {
      if (dragging || moved || opening) return;
      if (performance.now() - lastDragEndAt < 80) return;
      openTile(e.currentTarget);
    }

    function openTile(tile) {
      var parent = tile.parentElement;
      var it = items[num(parent, 'index', -1)];
      if (!it) return;
      var item = it.item;
      opening = true; openStartedAt = performance.now();
      lockScroll();
      focusedEl = tile; focusedItem = item;
      tile.setAttribute('data-focused', 'true');
      var rot = baseRotation(num(parent, 'offset-x', 0), num(parent, 'offset-y', 0), num(parent, 'size-x', 2), num(parent, 'size-y', 2), segments);
      var rotY = -(normalizeAngle(rot.rotateY) + normalizeAngle(rotation.y)) % 360;
      if (rotY < -180) rotY += 360;
      parent.style.setProperty('--rot-y-delta', rotY + 'deg');
      parent.style.setProperty('--rot-x-delta', (-rot.rotateX - rotation.x) + 'deg');

      var ref = el('div', 'item__image item__image--reference');
      ref.style.opacity = '0';
      ref.style.transform = 'rotateX(' + (-rot.rotateX) + 'deg) rotateY(' + (-rot.rotateY) + 'deg)';
      parent.appendChild(ref);
      void ref.offsetHeight;
      var tileR = ref.getBoundingClientRect(), mainR = main.getBoundingClientRect(), frameR = frame.getBoundingClientRect();
      if (tileR.width <= 0 || tileR.height <= 0) {
        opening = false; focusedEl = null; focusedItem = null; parent.removeChild(ref); unlockScroll(); return;
      }
      originalTilePos = { left: tileR.left, top: tileR.top, width: tileR.width, height: tileR.height };
      tile.style.visibility = 'hidden'; tile.style.zIndex = 0;

      var overlay = el('div', 'enlarge enlarge--' + item.kind);
      overlay.style.cssText = 'position:absolute;left:' + (frameR.left - mainR.left) + 'px;top:' + (frameR.top - mainR.top) + 'px;width:' + frameR.width + 'px;height:' + frameR.height + 'px;opacity:0;z-index:30;will-change:transform,opacity;transform-origin:top left;transition:transform ' + cfg.enlargeMs + 'ms ease, opacity ' + cfg.enlargeMs + 'ms ease;';
      var content = buildEnlarged(item);
      overlay.appendChild(content);
      viewer.appendChild(overlay);
      var sx0 = tileR.width / frameR.width, sy0 = tileR.height / frameR.height;
      overlay.style.transform = 'translate(' + (tileR.left - frameR.left) + 'px, ' + (tileR.top - frameR.top) + 'px) scale(' + (sx0 > 0 ? sx0 : 1) + ', ' + (sy0 > 0 ? sy0 : 1) + ')';

      setTimeout(function () {
        if (!overlay.parentElement) return;
        overlay.style.opacity = '1';
        overlay.style.transform = 'translate(0px, 0px) scale(1, 1)';
        root.setAttribute('data-enlarging', 'true');
      }, 16);

      /* second stage: settle into the kind-specific size, then start the clip */
      var firstDone = false;
      var onFirstEnd = function (ev) {
        if (ev && ev.propertyName !== 'transform') return;
        if (firstDone) return;
        firstDone = true; clearTimeout(firstFallback);
        overlay.removeEventListener('transitionend', onFirstEnd);
        var prev = overlay.style.transition;
        var size = openedSize(item, frameR);
        overlay.style.transition = 'none';
        overlay.style.width = size.w; overlay.style.height = size.h;
        var newRect = overlay.getBoundingClientRect();
        overlay.style.width = frameR.width + 'px'; overlay.style.height = frameR.height + 'px';
        void overlay.offsetWidth;
        overlay.style.transition = ['left', 'top', 'width', 'height'].map(function (p) { return p + ' ' + cfg.enlargeMs + 'ms ease'; }).join(', ');
        overlay.style.left = (frameR.left - mainR.left + (frameR.width - newRect.width) / 2) + 'px';
        overlay.style.top = (frameR.top - mainR.top + (frameR.height - newRect.height) / 2) + 'px';
        overlay.style.width = size.w; overlay.style.height = size.h;
        var secondDone = false;
        var cleanupSecond = function () {
          if (secondDone) return;
          secondDone = true; clearTimeout(secondFallback);
          overlay.removeEventListener('transitionend', cleanupSecond);
          overlay.style.transition = prev;
          if (content.tagName === 'VIDEO') { var p = content.play(); if (p && p.catch) p.catch(function () {}); }
        };
        var secondFallback = setTimeout(cleanupSecond, cfg.enlargeMs + 150);
        overlay.addEventListener('transitionend', cleanupSecond, { once: true });
      };
      var firstFallback = setTimeout(function () { onFirstEnd(null); }, cfg.enlargeMs + 150);
      overlay.addEventListener('transitionend', onFirstEnd);
    }

    /* ---------- close ---------- */
    function close() {
      if (performance.now() - openStartedAt < 250) return;
      var tile = focusedEl, item = focusedItem;
      if (!tile) return;
      var parent = tile.parentElement;
      var overlay = viewer.querySelector('.enlarge');
      if (!overlay) return;
      var vid = overlay.querySelector('video'); if (vid) vid.pause();
      var ref = parent.querySelector('.item__image--reference');
      var finish = function () {
        tile.removeAttribute('data-focused');
        focusedEl = null; focusedItem = null;
        root.removeAttribute('data-enlarging');
        opening = false;
        unlockScroll();
      };
      if (!originalTilePos) {
        overlay.remove(); if (ref) ref.remove();
        parent.style.setProperty('--rot-y-delta', '0deg'); parent.style.setProperty('--rot-x-delta', '0deg');
        tile.style.visibility = ''; tile.style.zIndex = 0;
        finish(); return;
      }
      var cur = overlay.getBoundingClientRect(), rootR = root.getBoundingClientRect();
      var anim = el('div', 'enlarge-closing');
      anim.style.cssText = 'position:absolute;left:' + (cur.left - rootR.left) + 'px;top:' + (cur.top - rootR.top) + 'px;width:' + cur.width + 'px;height:' + cur.height + 'px;z-index:9999;border-radius:var(--enlarge-radius,32px);overflow:hidden;box-shadow:0 10px 30px rgba(0,0,0,.35);transition:all ' + cfg.enlargeMs + 'ms ease-out;pointer-events:none;margin:0;transform:none;';
      if (item) anim.appendChild(buildFace(item));
      overlay.remove();
      root.appendChild(anim);
      void anim.getBoundingClientRect();
      var to = originalTilePos;
      requestAnimationFrame(function () {
        anim.style.left = (to.left - rootR.left) + 'px'; anim.style.top = (to.top - rootR.top) + 'px';
        anim.style.width = to.width + 'px'; anim.style.height = to.height + 'px';
        anim.style.opacity = '0';
      });
      var cleaned = false;
      var cleanup = function () {
        if (cleaned) return;
        cleaned = true; clearTimeout(fallback);
        anim.remove(); originalTilePos = null;
        if (ref) ref.remove();
        parent.style.transition = 'none';
        parent.style.setProperty('--rot-y-delta', '0deg'); parent.style.setProperty('--rot-x-delta', '0deg');
        void parent.offsetHeight; parent.style.transition = '';
        tile.style.transition = 'none'; tile.style.opacity = '0'; tile.style.visibility = ''; tile.style.zIndex = 0;
        void tile.offsetHeight;
        tile.style.transition = 'opacity 300ms ease-out'; tile.style.opacity = '1';
        setTimeout(function () { tile.style.transition = ''; tile.style.opacity = ''; }, 320);
        finish();
      };
      var fallback = setTimeout(cleanup, cfg.enlargeMs + 150);
      anim.addEventListener('transitionend', cleanup, { once: true });
    }
    scrim.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  function init(scope) {
    (scope.querySelectorAll ? scope : document).querySelectorAll('[data-dome]').forEach(initDome);
  }
  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
